import { Component, OnInit } from '@angular/core';
import { saveAs as importedSaveAs } from "file-saver";
import {BasketItem} from '../../../components/basket/basket-item'
import {BasketService} from '../../../components/basket/basket.service'
import * as moment from 'moment';
import { ReportableService } from '../../../services/reportable.service';
import { Router } from '@angular/router';
import { Category } from '../../../models/category';
import { Company } from '../../../models/company';
import { Equipment } from '../../../models/equipment';
import { Page } from '../../../models/paging/page';
import { AuthService } from '../../../services/auth.service';
import { CategoryService } from '../../../services/category.service';
import { CompanyService } from '../../../services/company.service';
import { EquipmentService } from '../../../services/equipment.service';
import { LocationService } from '../../../services/location.service';
import { FilterService } from '../../../services/filter.service';

@Component({
  selector: 'app-asset-register',
  templateUrl: './asset-register.component.html',
  styleUrls: ['./asset-register.component.scss']
})
export class AssetRegisterComponent implements OnInit {
  filter: any = {
    companyId: undefined,
    locationId: undefined,
    category_Id: 0,
    status: -1,
    serial_Num: '',
    asset_Num: '',
    job_No: '',
    contract_No: ''
  };
  completed_Statuses: any = [{ Name: "All", Value: -1 }, { Name: "Passed", Value: 0 }, { Name: "Failed", Value: 1 },
  { Name: "Not Located", Value: 2 }, { Name: "Not Inspected", Value: 3 }];

  loading: boolean = false;
  default_filters = JSON.parse(JSON.stringify(this.filter));

  pageno: number;
  locationList: Location[];

  companies: Company[];
  locations: Location[];

  categories: Category[];

  page = new Page();
  rows = Array<Equipment>();
  equipAccess = false;
  disableCompany = false;
  disableLocation= false;

  user;
  constructor(public companyService: CompanyService, public locationService: LocationService, public categoryService: CategoryService, private reportableService: ReportableService,
    public equipmentService: EquipmentService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    this.user = this.authService.currentUser.value;
    ////console.log(this.user);


    this.page.pageNumber = 0;
    this.page.size = 9999999;

    // Check if any filters are present
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null)
      this.filter = filters;

    /* this.loadTable(this.page);*/

  }

  ngOnInit(): void {
    this.bindClientValues();
  }
  bindClientValues() {
    if (this.user.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      if (this.user.companyId != undefined && this.user.companyId > 0) {
        this.filter.companyId = this.user.companyId;
        this.disableCompany = true;
      }

      if (this.user.locationId != undefined && this.user.locationId > 0) {
        this.filter.locationId = this.user.locationId;
        this.disableLocation = true;
        this.disableCompany = true;
      }

    }
  }
  onCompanyChange(value) {
    this.filter.locationId = undefined;

    if (value == undefined)
      this.filter.companyId = undefined;
    else
      this.filter.companyId = value.id;

  }

  onLocationChange(value) {
    if (value == undefined)
      this.filter.locationId = undefined;
    else
      this.filter.locationId = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.filter.categoryId = undefined;
    else
      this.filter.categoryId = value.id;
  }
  edit(row) {
    ////console.log(row);
    this.router.navigate(['admin/assets/manage'], { queryParams: { id: row.core_Id } });
  }
  add() {
    this.router.navigate(['admin/assets/manage']);
  }

  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.bindClientValues();
    this.loadTable(this.page);
  }

  rebind() {
    this.page.pageNumber = 0;
    this.loadTable(this.page);
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable(this.page);
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable(this.page);
  }

  loadTable(page: Page) {
    this.loading = true;
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.equipmentService.getAssetRegisterResults(this.page, this.filter.companyId, this.filter.locationId,
      this.filter.categoryId, this.filter.serial_Num, this.filter.asset_Num, this.filter.contract_No, this.filter.status,
      this.filter.job_No).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      ////console.log(this.rows);
      this.loading = false;
    });
  }

  generateExcel() {

    this.equipmentService.getExcel(this.page,
      this.filter.insurer_Id, this.filter.broker_Id,
      this.filter.companyId, this.filter.locationId,
      this.filter.category_Id, this.filter.serial_Num, this.filter.asset_Num).then((data) => {
        importedSaveAs(data, 'Equipment.xlsx');
      });
  }

  downloadReport(id, type) {
    this.reportableService.getROTE(id).then((data) => {
      importedSaveAs(data, type + ".pdf");
    })
  }

}
